import { useVoiceTranscriptPacer } from "@/hooks/use-voice-transcript-pacer"

import { useAppDispatch, useAppSelector } from "@/lib/storage/hooks"
import {
  selectAssistantSpeaking,
  selectAssistantWindowGated,
  selectAudibleAssistantResponseId,
  selectAudibleAssistantRevealedLength,
  selectAudibleAssistantText,
  selectCaptionSyllablesPerSecond,
  voiceChatActions,
} from "@/lib/storage/voice-chat-slice"

// Bridges the engine-owned audible-window projection into the caption scheduler.
// It paces only the response whose audio is physically audible: prior turns snap
// to full, and a response whose audio never started never reveals. The lower hook
// owns frame scheduling, not this selector bridge.
//
// Narrow, memoized selectors keep the audible text and length derivation from
// being rebuilt by the orb's ~25Hz audio-level updates; they recompute only when
// the live stream changes.
export function useAssistantCaptionPacer() {
  const dispatch = useAppDispatch()
  const captionSyllablesPerSecond = useAppSelector(
    selectCaptionSyllablesPerSecond
  )
  const audibleAssistantResponseId = useAppSelector(
    selectAudibleAssistantResponseId
  )
  const text = useAppSelector(selectAudibleAssistantText)
  const revealedLength = useAppSelector(selectAudibleAssistantRevealedLength)
  const assistantSpeaking = useAppSelector(selectAssistantSpeaking)
  const assistantWindowGated = useAppSelector(selectAssistantWindowGated)

  useVoiceTranscriptPacer({
    windowKey: audibleAssistantResponseId,
    text,
    revealedLength,
    syllablesPerSecond: captionSyllablesPerSecond,
    speaking: assistantSpeaking,
    windowGated: assistantWindowGated,
    onPace: (length) =>
      dispatch(voiceChatActions.assistantTranscriptPaced({ length })),
  })
}
